import { FC, useState } from 'react';
import { ConfirmOTPCode } from 'components/Auth/ConfirmOTPCode';
import { CustomButton } from 'components/shared';
import { RADABANK_OTP_LENGTH } from 'utils/constants';
import { getPhoneWithUACode } from 'utils/helpers';
import { RadabankService } from 'utils/services';
import { RestoreRadabankPasswordStepProps } from '../../data';

export const RestoreRadabankPasswordApproveStep: FC<RestoreRadabankPasswordStepProps> = ({
	onSaveData,
	initialValues,
	onError,
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [otp, setOtp] = useState<string>('');
	const [isValid, setIsValid] = useState(true);

	const handleChangeOtp = (value: string) => {
		setIsValid(true);
		setOtp(value);
	};

	const onSubmit = async () => {
		try {
			setIsLoading(true);
			await RadabankService.resetPasswordApprove({ ...initialValues, code: otp });
			onSaveData?.({ ...initialValues, code: otp });
		} catch (error) {
			onError(error);
			setIsValid(false);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			<ConfirmOTPCode
				value={otp}
				onChange={handleChangeOtp}
				isValid={isValid}
				phone={getPhoneWithUACode(initialValues.phone)}
				length={RADABANK_OTP_LENGTH}
				onSubmit={onSubmit}
			/>
			<CustomButton
				label="Продовжити"
				onClick={onSubmit}
				disabled={otp.length !== RADABANK_OTP_LENGTH}
				isLoading={isLoading}
				size="large"
			/>
		</>
	);
};
